import imageCompression from 'browser-image-compression';

const MAX_DIMENSION = 1920;
const MAX_SIZE_MB = 4;

export const prepareImageForUpload = async (file) => {
    if (!file) {
        throw new Error('No file selected');
    }

    if (file.type === 'image/svg+xml') {
        throw new Error('SVG images are not supported');
    }

    if (!file.type.startsWith('image/')) {
        throw new Error('Please select an image file');
    }

    const compressed = await imageCompression(file, {
        maxSizeMB: MAX_SIZE_MB,
        maxWidthOrHeight: MAX_DIMENSION,
        useWebWorker: true,
        fileType: 'image/webp',
    });

    return compressed;
};

export const getMediaCardUrl = (media) => media?.variants?.card?.url || null;

export const getMediaSrcSet = (media) => {
    if (!media?.variants) {
        return undefined;
    }

    const parts = [];
    if (media.variants.thumb?.url) {
        parts.push(`${media.variants.thumb.url} 150w`);
    }
    if (media.variants.card?.url) {
        parts.push(`${media.variants.card.url} 400w`);
    }
    if (media.variants.full?.url) {
        parts.push(`${media.variants.full.url} 1200w`);
    }

    return parts.length ? parts.join(', ') : undefined;
};
